import React, { useState } from 'react';
import { ArrowForwardIcon } from '@rsos/assets/icons';
import { Text } from '@rsos/components/capstone/base';
import { CENTRAL_STATION } from '@rsos/constants/appNames';
import { useAppSelector } from '@rsos/utils/reduxHooks';
import { ShareButton, ShareButtonContentWrapper } from './ShareIncident.styles';

const BUTTON_LABEL = 'Share';
const BUTTON_LABEL_HOVER = 'Share to Responder';

const ShareIncidentButton = ({ setIsShareIncidentModalOpen }) => {
  const [isButtonLabelHover, setIsButtonLabelHover] = useState(false);
  const isCentralStation = useAppSelector(
    state => state.sinatra?.user?.currentRole?.application === CENTRAL_STATION,
  );

  const handleMouseOver = () => {
    setIsButtonLabelHover(true);
  };
  const handleMouseLeave = () => {
    setIsButtonLabelHover(false);
  };
  return (
    <ShareButton
      onClick={() => setIsShareIncidentModalOpen(true)}
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
    >
      <ShareButtonContentWrapper>
        <ArrowForwardIcon />
        <Text size="xsmall">
          {isButtonLabelHover && !isCentralStation
            ? BUTTON_LABEL_HOVER
            : BUTTON_LABEL}
        </Text>
      </ShareButtonContentWrapper>
    </ShareButton>
  );
};

export default ShareIncidentButton;
